<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <!-- Business Banner -->
    <BannerComponent
      imageSrc="capabilities/business intelligence/title-page-business-intelligence.jpg"
      :bannerHeadingColor="'#fff'"
      :isOverlay="true"
      heading="Business Intelligence"
      subheading="Illuminate the Path to Success"
    />

    <div class="modernization-description" data-aos="fade-up">
      <v-row>
        <v-col
          :xs="12"
        >
          <p> {{ appModernizationDesc }} </p>
        </v-col>
      </v-row>
    </div>
    <CardComponent 
      :subHeading="`BENEFITS`"
      :cardItems="benefitsItems"
    />
    <CardComponent 
      :subHeading="`CORE CAPABILITIES`"
      :cardItems="coreCapabilitiesItems"
    />
    <SectionComponent
      relatedTitle="RELATED CAPABILITIES AND SOLUTIONS"
      :paragraphContent="paragraphContent"
      :sections="sectionContents"
      :cards="cardData"
      :additional-content="additionalContent"
    />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/BannerComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    CardComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
      appModernizationDesc: 'G14C Business Intelligence capabilities provides decision makers with actionable information for making optimal business decisions. Our services provide business leaders with the information they need to improve business processes, reporting capabilities, and their business.',
      benefitsItems: [
        {
          id: 0,
          subFolder:'capabilities',
          folder: 'business intelligence',
          imageUrl: 'data-quality.jpg',
          text: 'Data Quality',
          hoverIcon: 'vector.png',
          hoverText: 'Provides data quality and data analysis expertise to ensure the accuracy, completeness, consistency, timeliness, relevance, and validity of data. Our capabilities include data cleansing, troubleshooting, and analysis of data accuracy, reliability, and relevancy to ensure our customer’s data is fit-for-use for the intended purpose.'
        },{
          id: 1,
          subFolder:'capabilities', 
          folder: 'business intelligence',
          imageUrl: 'reporting.jpg',
          text: 'Effective and Accurate Reporting',
          hoverIcon: 'chart.png',
          hoverText: 'Supports our customer’s business intelligence needs by effectively collecting, analyzing, and presenting data providing insights to decision-makers. Analyzes data relevance, contextualization, and ensures accessibility, and provides actionable insights.'
        },{
          id: 2,
          subFolder:'capabilities',
          folder: 'business intelligence',
          imageUrl: 'business-insight.jpg',
          text: 'Improve Business Insights ',
          hoverIcon: 'trend-down.png',
          hoverText: 'Improves business insights by defining objectives, collecting and analyzing relevant data, using visualization tools to display data, collaborating with stakeholders, and continuously monitoring and evaluating to ensure the data remains up-to-date and relevant.'
        },{
          id: 3,
          subFolder:'capabilities',
          folder: 'business intelligence',
          imageUrl: 'leading edge architecture.jpg',
          text: 'Leading Edge Architecture',
          hoverIcon: 'lock.png',
          hoverText: 'Delivers expertise to ensure that your business intelligence platform provides predictive analytics utilizing emerging trends in generative AI and ML leveraging open standards in secure operating environment.'
        }
      ],
      coreCapabilitiesItems: [
        {
          id: 4,
          subFolder:'capabilities',
          folder: 'business intelligence',
          imageUrl: 'analytics.jpg',
          text: 'Analytics',
          hoverIcon: 'analysis.png',
          hoverText: 'Providing services covering the entire continuum of analytics from modeling to AI and ML. Our capabilities include data mining, and data streaming to embed analytics into enterprise processes and systems. Through technology implementation and consulting, we ensure the adoption of quantitative and qualitative decision- making across the enterprise.'
        },{
          id: 5,
          subFolder:'capabilities',
          folder: 'business intelligence',
          imageUrl: 'data modeling.jpg',
          text: 'Data Science and Modelling ',
          hoverIcon: 'inventory.png',
          hoverText: 'Industry leader in statistical and mathematical modeling. Our data scientists have deep data science expertise developing, training, and tuning scientific-data-models, and our data engineers have technical expertise embedding and automating analytics, facilitating model creation, data tagging, and blending of data.'
        },{
          id: 6,
          subFolder:'capabilities',
          folder: 'business intelligence',
          imageUrl: 'governance.jpg',
          text: 'Governance',
          hoverIcon: 'ai-brain.png',
          hoverText: 'Performing data governance activities supporting policies, procedures, and controls to ensure the appropriate use, management, and protection of an organizations data assets. Specializing in the creation and enforcement of guidelines for data management and usage, including data security, data quality, data privacy, data ethics, and regulatory compliance.'
        },{
          id: 7,
          subFolder:'capabilities',
          folder: 'business intelligence',
          imageUrl: 'interoperability.jpg',
          text: 'Interoperability',
          hoverIcon: 'cloud-done.png',
          hoverText: 'Specializing in automating, optimizing, enhancing, and protecting information exchange by accessing and integrating multiple data sources to deliver business intelligence through data visualization, reporting, dashboards, and portals.'
        },{
          id: 8,
          subFolder:'capabilities',
          folder: 'business intelligence',
          imageUrl: 'virtualization.jpg',
          text: 'Virtualization',
          hoverIcon: 'software-license.png',
          hoverText: 'Our data virtualization capabilities allow users to access and manipulate data from multiple sources without the use of a central repository. Our solutions enable businesses the ability to access virtualized data from data lakes, data lake houses, and data warehouses on-demand to improve agility, lower costs, improve quality, an increase flexibility.'
        },{
          id: 9,
          subFolder:'capabilities',
          folder: 'business intelligence',
          imageUrl: 'visualization.jpg',
          text: 'Visualization',
          hoverIcon: 'microservices.png',
          hoverText: 'Delivering data visualization solutions for representing data and information in a clean organized graphical presentation accessible using dashboards and portals helping users gain insights from their data. Implementing data visualization solutions that aggregates complex data and presents it in a clear and concise manner so that the data is easily understood. '
        }
      ],
      paragraphContent: "Our certified business intelligence and data analyst experts specialize in transforming complexity into self-service and easily customizable business intelligence solutions that improve an organizations ability to make informed, accurate and timely business decisions. Our implementation approach is highly collaborative resulting in rapid adoption of modern analytical platforms and technologies based on scientific data models, leveraging AI and ML to empower your workforce.",
      sectionContents: [
        '“Please allow me to reiterate how happy we all are about how well the [Stolen Asset Recovery] StAR and Law Library business intelligence projects have been conducted and how much I personally enjoy working with the team. It has been my pleasure getting to know everyone and working with them on these projects.”',
        '“Your contributions designing, creating and implementing business intelligence solutions for the brigades and battalions enabled the team’s success and has paved the way for our organizations and other Centers of Excellence.”',
      ],
      additionalContent: [
        'World Bank, Program Manager', 
        'USAACE, Commanding General', 
      ],
      cardData: [
        {
          className: 'cloud',
          color: '#7594FE',
          heading: 'Application Modernization	',
          link: 'application-modernization'
        },
        {
          className: 'devsecops',
          color: '#50E1FE',
          heading: 'Digital Services',
          link: 'digital-services'
        },
        {
          className: 'security',
          color: '#E2BF66',
          heading: 'National Security Services',
          link: 'national-security-services'
        },
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.modernization-description{
  padding: 32px;
  padding-left: 100px;
  padding-right: 100px;
}
.modernization-description div div p{
  font-size: 24px;
}
@media (max-width: 1000px) {
  .modernization-description{
    padding: 27px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modernization-description div div p{
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  .modernization-description{
    padding: 22px;
    padding-left: 65px;
    padding-right: 65px;
  }
  .modernization-description div div p{
    font-size: 22px;
  }
}
@media (max-width: 750px) {
  .modernization-description{
    padding: 17px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .modernization-description div div p{
    font-size: 20px;
  }
}
@media (max-width: 600px) {
  .modernization-description{
    padding: 12px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .modernization-description div div p{
    font-size: 18px;
  }
}
</style>